import { render } from "./Top.vue?vue&type=template&id=005f63a9&scoped=true"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"

import "@/assets/css/style_top.css?vue&type=style&index=0&id=005f63a9&lang=css&scoped=true"
import "@/assets/css/style_parts.css?vue&type=style&index=1&id=005f63a9&lang=css&scoped=true"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005f63a9"]])

export default __exports__